module.exports = __webpack_public_path__ + "media/zq+qh-hk.cb7d01e2.mp3";